import { render, staticRenderFns } from "./PersonalData.vue?vue&type=template&id=b939437e&scoped=true&"
import script from "./PersonalData.vue?vue&type=script&lang=js&"
export * from "./PersonalData.vue?vue&type=script&lang=js&"
import style0 from "./PersonalData.vue?vue&type=style&index=0&id=b939437e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b939437e",
  null
  
)

export default component.exports